export default "<span style=\"font-size: 22pt;\" class=\"bold-text\" [innerHTML]=\"message\"> </span>";